import React from "react";

export default function Stats() {
    return (
        <div className="flex justify-center">
            <div className="text-center px-4">
                <h2 className="text-xl font-bold">10k</h2>
                <p className="text-sm">Active users</p>
            </div>
            <div className="text-center px-4">
                <h2 className="text-xl font-bold">25+</h2>
                <p className="text-sm">Grants Category</p>
            </div>
            <div className="text-center px-4">
                <h2 className="text-xl font-bold">15k</h2>
                <p className="text-sm">Grants</p>
            </div>
        </div>
    );
}
